import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromTour from './tour.reducer';
import * as ExhibitionState from '@exhibition/_ngrx/exhibition.selectors'
import { TourDto } from '@api/rest';

export const selectTourState = createFeatureSelector<fromTour.State>(
  fromTour.toursFeatureKey
);

export const getTours = createSelector(selectTourState, fromTour.selectAll);
export const getToursDict = createSelector(selectTourState, fromTour.selectEntities);
export const getSelectedId = createSelector(selectTourState, state => state.selected);

export const getSelected = createSelector(
  getToursDict,
  getSelectedId,
  (tours, id): TourDto => tours[ id ]
);

export const getExhibitionTours = createSelector(
  getToursDict,
  ExhibitionState.getSelected,
  (
    dict,
    exhibition
  ): TourDto[] => exhibition?.tour_refs?.map(ref => dict[ ref ]).filter(Boolean) || []
);
